{
  "es": {
    "milestone": {
      "actions": {
        "activate": "Activar",
        "active": "¡Activo!",
        "create": "Crear hito",
        "deactivate": "Desactivar",
        "delete": "Eliminar",
        "delete_milestones": "Eliminar hito | Eliminar {count} hitos",
        "new": "Hito"
      },
      "activate": {
        "confirm": "Activar",
        "intro": "Al activar este hito:",
        "past_warning": "Volver a un hito anterior no deshará lo que ya ha ocurrido. Nada de lo compartido con los clientes se revocará automáticamente.",
        "title": "Activar hito",
        "verb_default": "Iniciar",
        "verb_share": "Compartir"
      },
      "attach": {
        "add": "Añadir",
        "add_kind": "Añadir {kind}",
        "assigned_tag": "Asignado",
        "back": "Atrás",
        "counts": "{available} disponibles · {assigned} ya asignados",
        "description_decision": "Opciones que el cliente debe elegir",
        "description_survey": "Encuestas para recopilar opiniones",
        "empty": "No hay elementos disponibles",
        "empty_state_description": "Según tu plan, puedes añadir {kinds} a este hito.",
        "intro": "Elige qué tipo de elemento quieres vincular a este hito.",
        "next": "Siguiente",
        "search": "Buscar",
        "select_intro": "Selecciona {kind} que quieras añadir.",
        "subtitle": "Al hito: {name}",
        "success": "Elementos añadidos",
        "title": "Añadir elementos"
      },
      "labels": {
        "add_element": "Añadir elemento",
        "add_kind": "Añadir {kind}",
        "assign_units": "Asignar unidades",
        "assigned_count": "0 asignados | 1 asignado | {count} asignados",
        "assigned_elements": "Elementos asignados",
        "assigned_empty_description": "Vincula {kinds} a este hito",
        "assigned_empty_title": "Todavía no hay elementos",
        "bulk_assign_title": "Selecciona las unidades a las que quieres asignar el hito «{milestone_name}»",
        "edit_milestone": "Editar hito",
        "empty_state_subtitle": "Los hitos hacen que el proceso de construcción sea más transparente para los compradores",
        "empty_state_title": "Crea un nuevo hito",
        "finished_on": "Finalizado el {date}",
        "future_milestones": "Hitos futuros",
        "kind_decision": "Decisión | Decisiones",
        "kind_survey": "Encuesta | Encuestas",
        "kind_todo": "Tarea | Tareas",
        "milestone": "Hito",
        "milestone_name": "Nombre del hito",
        "milestone_unit_count": "0 unidades | 1 unidad | {count} unidades",
        "milestones": "Hitos",
        "new_milestone": "Nuevo hito",
        "no_milestone": "Todavía no hay ningún hito asignado",
        "no_results": "No se han encontrado hitos",
        "past_milestones": "Hitos pasados",
        "please_select": "Selecciona un nuevo hito",
        "position": "Posición",
        "search_empty_state": "Todavía no se han creado hitos. Haz clic aquí para empezar",
        "started_on": "Iniciado el {date}",
        "status_active": "Activo",
        "status_completed": "Completado",
        "status_planned": "Planificado",
        "status_planned_subtitle": "Todavía no ha empezado",
        "unit_timeline_empty": "Todavía no se han creado hitos para este proyecto.",
        "units": "Unidades",
        "units_without_milestone": "1 unidad sin hito | {count} unidades sin hito",
        "warning_delete": "Si eliminas un hito que está asignado a una unidad, el cliente dejará de ver en qué hito se encuentra su unidad. ¡Asegúrate de asignar un nuevo hito a esas unidades!"
      },
      "toasts": {
        "bulk_assigned": "El hito se ha asignado correctamente a las unidades seleccionadas",
        "create_success": "Hito creado correctamente",
        "deactivate_success": "El hito se ha desactivado correctamente",
        "sup_assigned": "El hito se ha activado correctamente",
        "update_success": "Los hitos se han actualizado correctamente"
      },
      "validation": {
        "needName": "El nombre es obligatorio",
        "needNamePrimary": "Se requiere el nombre en el idioma principal ({language})"
      }
    }
  }
}
